import { combineReducers } from 'redux';

import byId from './byId';
import defaultQuestionId from './defaultQuestionId';

/**
 * @typedef {{
 *   byId: import('./byId').ByIdReducer,
 *   defaultQuestionId: string,
 * }} QuestionModelsDataReducer
 */

export default combineReducers({
  byId,
  defaultQuestionId,
});
